<template>
  <!--=== banner ==========-->
  <div v-if="bannerTopo != ''" class="slider-area topo-cel">
    <div class="slider-height2 slider-bg4 hero-overly d-flex align-items-center"
      :style="{ backgroundImage: 'url(' + $imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-5 col-lg-6 col-md-6">
            <div class="hero-caption hero-caption2">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  final banner -->

  <!--=== noticia ==========-->
  <section v-if="linhaTextoNoticia != ''" class="blog_area single-post-area section-padding">
    <div class="container">
      <div class="row align-items-center justify-content-center">
        <div class="col-lg-10 posts-list">
          <div class="single-post">
            <div class="feature-img">
              <img :style="{ backgroundImage: 'url(' + $imgURL + linhaTextoNoticia.insInstitucionalImagens[0].itgUrlImagem + ')' }" class="card-img-avance rounded-0" alt="">
            </div>
            <div class="blog_details">
              <h2>{{ linhaTextoNoticia.itiNome }}</h2>
              <p v-html="linhaTextoNoticia.itiResumo1"></p>
              
              <!-- link para voltar -->
              <div>
                <button onclick="history.back()" style="cursor: pointer;"><p>← Voltar</p></button>
              </div>
              
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
  <!-- final noticia -->

</template>

<script>
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head';
import axios from 'axios';

export default {
  name: 'BlogDetalheView',
  components: {
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    bannerTopo: [],
    linhaTextoNoticia: [],
  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Igor Paper - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Igor Paper" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {
    this.carregaMetas("---");

    //aqui banner topo
    axios.get('/Process/InsInstitucional/institucional/45/blogtopo/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        //console.log('banner blog')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    axios.get('/Process/InsInstitucional/GetById/' + this.id)
      .then(response => {
        this.linhaTextoNoticia = response.data;
        this.carregaMetas(this.removerTagsHTML(this.linhaTextoNoticia.itiDescricao1), this.linhaTextoNoticia.itiNome);
        //console.log('this.linhaTextoNoticia')
        //console.log(this.linhaTextoNoticia)

      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style scoped></style>